export default "__VITE_ASSET__DOVCMlYK__"